/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayInfraRedControlToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, infraRedControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null };

export type ConfigUpdateInfraRedControlMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateInfraRedControlInput;
}>;


export type ConfigUpdateInfraRedControlMutation = { __typename: 'Mutation', configurationUpdateInfraRedControl: { __typename: 'ConfigurationModel', id: string, infraRedControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null } };

export const ConfigDisplayInfraRedControlToggle_ConfigFragmentDoc = gql`
    fragment ConfigDisplayInfraRedControlToggle_config on ConfigurationModel {
  id
  infraRedControl {
    reported
    supportedValues
  }
}
    `;
export const ConfigUpdateInfraRedControlDocument = gql`
    mutation ConfigUpdateInfraRedControl($input: ConfigurationUpdateInfraRedControlInput!) {
  configurationUpdateInfraRedControl(input: $input) {
    id
    infraRedControl {
      reported
      supportedValues
    }
  }
}
    `;
export type ConfigUpdateInfraRedControlMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateInfraRedControlMutation, ConfigUpdateInfraRedControlMutationVariables>;

/**
 * __useConfigUpdateInfraRedControlMutation__
 *
 * To run a mutation, you first call `useConfigUpdateInfraRedControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateInfraRedControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateInfraRedControlMutation, { data, loading, error }] = useConfigUpdateInfraRedControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateInfraRedControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateInfraRedControlMutation, ConfigUpdateInfraRedControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateInfraRedControlMutation, ConfigUpdateInfraRedControlMutationVariables>(ConfigUpdateInfraRedControlDocument, options);
      }
export type ConfigUpdateInfraRedControlMutationHookResult = ReturnType<typeof useConfigUpdateInfraRedControlMutation>;
export type ConfigUpdateInfraRedControlMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateInfraRedControlMutation>;
export type ConfigUpdateInfraRedControlMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateInfraRedControlMutation, ConfigUpdateInfraRedControlMutationVariables>;